<script>
import ElColorPicker from 'element-ui/lib/color-picker'

export default {
  // 色盘直接读取父组件颜色，不能再套一层组件。
  name: 'ElColorPicker',
  extends: ElColorPicker,
  render (h) {
    const context = Object.create(this)
    Object.defineProperty(context, 'popperClass', {
      value: ['ui-color-picker-popper', this.popperClass].filter(Boolean).join(' ')
    })
    const vnode = ElColorPicker.render.call(context, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-color-picker']
    return vnode
  }
}
</script>
